import { useCallback, useMemo } from 'react'
import { InputNumberWithLabelMargin, RectangularInputFormatNumberSmall } from '..'
import { getCurrencySymbol } from '../../../utils/globals/price'
import CustomSelect from '../../CustomSelect'
import { InputDiscountValue, MaxDiscount } from './types'
import { TwinDictionary } from '../../../utils/globals/dictionary'
import { OrderProductDiscountTypesKeys } from '@teinor/erp/types/company/order/general'
import { RowData } from '../../../baseComponents/TwinTable/types'
import './inputDiscount.sass'

export interface InputDiscountBaseProps extends InputDiscountLogicProps {
    CurrencyId: string
    className?: string
    readOnly?: boolean
    priceField?: string
    readOnlyFnc?: (allRowData: RowData) => boolean
}

export interface RectangularInputDiscountProps extends InputDiscountBaseProps {
    avaliableItems?: TwinDictionary
}

export const RectangularInputDiscount: React.FC<RectangularInputDiscountProps> = ({ value, CurrencyId, onChange, className, maxDiscount, readOnly , avaliableItems}) => {
    const items: TwinDictionary = useMemo(() => { return avaliableItems || { 0: { name: '%' }, 1: { name: getCurrencySymbol(CurrencyId) }, 2: { name: getCurrencySymbol(CurrencyId) + ' /u' } } }, [CurrencyId, avaliableItems]) 
    const { changeValue, changeType } = useInputDiscountLogic({ value, onChange, maxDiscount})
    return (
        <div className={'input_discount input_discount_rectangular flex items-center ' +  (className || '')}>
            <RectangularInputFormatNumberSmall className='h-29' value={value?.discount || ''} onChange={changeValue} readOnly={readOnly} allowEmpty={true} />
            <CustomSelect className='custom_select_discount' hideLabel={true} label='' items={items} value={value?.typeDiscount || 0} onChange={changeType} readOnly={readOnly}></CustomSelect>
        </div>
    )
}

export interface InputDiscountProps extends InputDiscountBaseProps {
    label: string
    avaliableItems?: TwinDictionary
}


const InputDiscount: React.FC<InputDiscountProps> = ({ value, label, CurrencyId, onChange, className, maxDiscount, readOnly, avaliableItems }) => {
    const items: TwinDictionary = useMemo(() => { return avaliableItems || { 0: { name: '%' }, 1: { name: getCurrencySymbol(CurrencyId) }} }, [CurrencyId, avaliableItems]) 
    const { changeValue, changeType } = useInputDiscountLogic({ value, onChange, maxDiscount })
    return (
        <div className={'input_discount flex-auto flex items-center ' +  (className || '')}>
            <InputNumberWithLabelMargin label={label} className='flex-auto w-1' value={value?.discount || ''} onChange={changeValue} readOnly={readOnly} allowEmpty={true} hideLabel={true} />
            <CustomSelect className='custom_select_discount' label='' items={items} value={value?.typeDiscount || 0} onChange={changeType} readOnly={readOnly}></CustomSelect>
        </div>
    )
}

interface InputDiscountLogicProps {
    onChange?: (value: InputDiscountValue) => void
    value?: InputDiscountValue
    maxDiscount: MaxDiscount
}


const useInputDiscountLogic = ({ value, onChange, maxDiscount}: InputDiscountLogicProps) => {
    const changeValue = useCallback((myValue: string) => {
        const myMax: TwinDictionary = {
            0: maxDiscount.maxPercentageDiscount,
            1: maxDiscount.maxTotalDiscount,
            2: maxDiscount.maxUnitDiscount
        }
        const typeDiscount = parseInt(String(value?.typeDiscount))
        const valueParsed = parseFloat(myValue)
        if (valueParsed >= myMax[typeDiscount]) {
            onChange?.({ discount: myMax[typeDiscount], typeDiscount: value?.typeDiscount })
        }else {
            onChange?.({ discount: myValue, typeDiscount: value?.typeDiscount })
        }
    }, [onChange, value, maxDiscount])

    const changeType = useCallback((myValue: OrderProductDiscountTypesKeys) => {
        onChange?.({ discount: '', typeDiscount: myValue })
    }, [onChange])

    return { changeValue, changeType }
}


export default InputDiscount